import { t } from '@core/i18n';
import {
  clearBrowserCaches,
  clearStoredPreferences,
  getStorageConsent,
  setStorageConsent,
  type StorageConsent,
} from '@core/privacy';
import { clearStoredGameData } from '@core/session';
import { el } from './dom';

let activeDialog: HTMLElement | null = null;

function consentStatus(): HTMLElement | null {
  const current = getStorageConsent();
  if (!current) return null;
  return el('p', { class: 'text-xs text-slate-400' }, [
    t(current === 'accepted' ? 'privacy.current.accepted' : 'privacy.current.rejected'),
  ]);
}

async function applyChoice(choice: StorageConsent, onChange?: () => void): Promise<void> {
  setStorageConsent(choice);
  if (choice === 'rejected') {
    clearStoredPreferences();
    await clearStoredGameData();
    await clearBrowserCaches();
    setStorageConsent('rejected');
  }
  activeDialog?.remove();
  activeDialog = null;
  onChange?.();
}

export function openConsentSettings(args: { required?: boolean; onChange?: () => void } = {}): void {
  activeDialog?.remove();

  const actions = el('div', { class: 'flex flex-col sm:flex-row gap-2 sm:justify-end' }, [
    el(
      'button',
      {
        class: 'btn-ghost',
        on: { click: () => void applyChoice('rejected', args.onChange) },
      },
      [t('privacy.reject')],
    ),
    el(
      'button',
      {
        class: 'btn-primary',
        on: { click: () => void applyChoice('accepted', args.onChange) },
      },
      [t('privacy.accept')],
    ),
    args.required
      ? null
      : el(
          'button',
          {
            class: 'btn-ghost',
            on: {
              click: () => {
                activeDialog?.remove();
                activeDialog = null;
              },
            },
          },
          [t('privacy.close')],
        ),
  ]);

  activeDialog = el('div', { class: 'fixed inset-0 z-[100] bg-bg/80 backdrop-blur-sm p-4 grid place-items-end sm:place-items-center' }, [
    el('section', { class: 'card w-full max-w-xl grid gap-4' }, [
      el('div', { class: 'grid gap-2' }, [
        el('h2', { class: 'text-xl font-bold' }, [t('privacy.title')]),
        el('p', { class: 'text-sm text-slate-300 leading-relaxed' }, [t('privacy.body')]),
        consentStatus(),
      ]),
      actions,
    ]),
  ]);

  document.body.append(activeDialog);
}

export function showConsentBanner(): void {
  if (!getStorageConsent()) {
    openConsentSettings({ required: true });
  }
}